import React from 'react';

import { noop } from '@/_shared';

import type { FormErrorsContextType } from './types';

export const FormErrorsContext = React.createContext<FormErrorsContextType>({
  errors: {},
  setErrors: noop,
  resetErrors: noop,
});
